import React from "react";
import "./BookingTrackingSkeleton.scss";

/**
 * Skeleton loader component displayed while booking details are being fetched from the API.
 * This provides a better user experience by showing placeholder content instead of a blank screen.
 * Structure matches BookingTrackingContainer component hierarchy.
 */
export const BookingTrackingSkeleton: React.FC = () => {
    return (
        <div className="tracking-outer-container">
            <div className="tracking-main-container">
                {/* Booking status skeleton - matches "Searching for driver" state */}
                <div className="skeleton-status skeleton-shimmer"></div>

                {/* Passenger name skeleton */}
                <div className="skeleton-passenger-name skeleton-shimmer"></div>

                {/* Addresses skeleton */}
                <div className="skeleton-addresses">
                    <div className="skeleton-address-row">
                        <div className="skeleton-address-icon skeleton-shimmer"></div>
                        <div className="skeleton-address-text skeleton-shimmer"></div>
                    </div>
                    <div className="skeleton-address-row">
                        <div className="skeleton-address-icon skeleton-shimmer"></div>
                        <div className="skeleton-address-text skeleton-shimmer"></div>
                    </div>
                    <div className="skeleton-trip-duration skeleton-shimmer"></div>
                </div>

                {/* Separator */}
                <div className="skeleton-separator"></div>

                {/* Fare section skeleton */}
                <div className="skeleton-fare-section">
                    <div className="skeleton-fare-title skeleton-shimmer"></div>
                    <div className="skeleton-fare-subtitle skeleton-shimmer"></div>
                    
                    {/* Metered fare option */}
                    <div className="skeleton-fare-option">
                        <div className="skeleton-fare-option-content">
                            <div className="skeleton-fare-option-left">
                                <div className="skeleton-fare-radio skeleton-shimmer"></div>
                                <div className="skeleton-fare-option-text">
                                    <div className="skeleton-fare-type skeleton-shimmer"></div>
                                    <div className="skeleton-fare-description skeleton-shimmer"></div>
                                </div>
                            </div>
                            <div className="skeleton-fare-amount skeleton-shimmer"></div>
                        </div>
                    </div>
                    
                    {/* Fixed fare option */}
                    <div className="skeleton-fare-option">
                        <div className="skeleton-fare-option-content">
                            <div className="skeleton-fare-option-left">
                                <div className="skeleton-fare-radio skeleton-shimmer"></div>
                                <div className="skeleton-fare-option-text">
                                    <div className="skeleton-fare-type skeleton-shimmer"></div>
                                    <div className="skeleton-fare-description skeleton-shimmer"></div>
                                </div>
                            </div>
                            <div className="skeleton-fare-amount skeleton-shimmer"></div>
                        </div>
                    </div>
                </div>

                {/* Reference skeleton */}
                <div className="skeleton-reference skeleton-shimmer"></div>

                {/* Action buttons skeleton */}
                <div className="skeleton-action-buttons">
                    <div className="skeleton-action-button skeleton-shimmer"></div>
                    <div className="skeleton-action-button skeleton-shimmer"></div>
                </div>
            </div>
        </div>
    );
};
